import DAZZMLogo from './DAZZMLogo.jsx';

export default function AccessDenied() {
  const language = navigator.language.startsWith('fr') ? 'fr' : 'en';

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#2b2b2b',
        color: '#80daff',
        backgroundImage: "url('/__assets/global/7d4d8f19-77aa-4c3a-882c-48650c2cb153')",
        backgroundPosition: '50% 50%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: '100%',
          width: '800px'
        }}
      >
        <DAZZMLogo />
        {language === 'en' ? <EnglishContent /> : <FrenchContent />}
      </div>
    </div>
  );
}

function EnglishContent() {
  return (
    <>
      <h1 style={{ textAlign: 'center' }}>Access Limited</h1>
      <h2 style={{ textAlign: 'center' }}>
        We apologize for the inconvenience, but access to this application is currently restricted
        based on the existing access policy.
      </h2>
      <h2 style={{ textAlign: 'center' }}>
        For assistance in resolving this matter, please consult with your organization&apos;s IT
        support or system administrator.
      </h2>
    </>
  );
}

function FrenchContent() {
  return (
    <>
      <h1 style={{ textAlign: 'center' }}>Accès Limité</h1>
      <h2 style={{ textAlign: 'center' }}>
        Nous nous excusons pour le désagrément, mais l&apos;accès à cette application est
        actuellement restreint en fonction de la politique d&apos;accès en vigueur.
      </h2>
      <h2 style={{ textAlign: 'center' }}>
        Pour obtenir de l&apos;aide afin de résoudre ce problème, veuillez consulter le support
        informatique ou l&apos;administrateur système de votre organisation.
      </h2>
    </>
  );
}
